import React from 'react';
import { Meteor } from 'meteor/meteor';
import ReactDOM from 'react-dom';
import { Tracker } from 'meteor/tracker';
import {
	Col,
	BPanel,
	FormControl,
	FormGroup,
	ControlLabel,
	Table,
	Button,
	Checkbox
} from '@sketchpixy/rubix';
import { Reactive } from '../../common/Reactive.mixin';
import { FlightsType } from '../../../collections/flights-type/flights-type';
import { Prices } from '../../../collections/flights-type/prices';

@Reactive({
	subscriptions: ["flights-type"],
})
export class SpecialPricesComponent extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {};
		this.state.user = props.user;
		this.state.prices = [];
		props.ready.then(() => {
			Tracker.nonreactive(() => {
				this.setState({
					flights: FlightsType.find({partnerId:null}).fetch(),
					selectedFlight: FlightsType.find({partnerId:null}).fetch()[0],
					specialFlights: FlightsType.find({partnerId: props.user._id}).fetch()
				});
			});
		});
	}


	renderFlights() {
		return this.state.specialFlights.map((flight) => (
			<tr>
				<td>{flight.title}</td>
				<td>{flight.prices()[0].title}</td>
				<td>{flight.prices()[0].price}€</td>
				<td className="text-center"><Button bsStyle="danger" onClick={this.onDelete.bind(this, flight._id)}>Supprimer</Button></td>
			</tr>
		));
	}

	selectFlight() {
		let id = ReactDOM.findDOMNode(this.refs.flight).value;

		this.setState({
			selectedFlight: FlightsType.findOne(id)
		});
	}

	onDelete(value) {
		    
		    Meteor.call('flightsType.remove', value, (function (err, _id) {

			if (err) {
				Messenger().post({
					message: "Erreur lors de la suppression.",
					type: "error"
				});
				return; 
			}

			Messenger().post({
				message: "Le vol a bien été supprimé.",
				type: "success"
			});

			this.setState({
				flights: FlightsType.find({partnerId:null}),
				specialFlights: FlightsType.find({partnerId: this.state.user._id}).fetch()
			});

		}).bind(this));
	}

	onAdd() {
		let params = {};
		let message = null;
		let method = null;

		params.attributes = {};
		_.each(this.refs, (ref, key) => {
			params.attributes[key] = ReactDOM.findDOMNode(ref).value.trim();   
		});

		message = "Le vol a été ajouté avec succès.";
		method = "flightsType.insertPartner";

		let clone = FlightsType.findOne(params.attributes['flight']);
		clone.partnerId = this.state.user._id;
		clone.quantity = params.attributes['quantity'];
		
		clone.priceSemaine = ReactDOM.findDOMNode(this.refs.priceSemaine).value.trim();
		clone.priceLibreDate = ReactDOM.findDOMNode(this.refs.priceLibreDate).value.trim();
		clone.priceEnfant = ReactDOM.findDOMNode(this.refs.priceEnfant).value.trim();

		params.attributes = clone;

		Meteor.call(method, params, (function (err, _id) {

			if (err) {
				Messenger().post({
					message: err,
					type: "error"
				});
				return; 
			}

			Messenger().post({
				message: message,
				type: "success"
			});

			this.setState({
				specialFlights: FlightsType.find({partnerId: this.state.user._id})
			});

		}).bind(this));
	}

	render() {

	  	if(!this.props.isReady || !this.state.specialFlights || !this.state.selectedFlight) {
	  		return (
	  			<div>Chargement...</div>
	  		);
	  	}

		return (
			<Col sm={12}>
				<Col sm={12}>
					<Table striped bordered condensed hover responsive>
						<thead>
							<tr>
								<th>Type</th>
								<th>Tarifs spéciaux</th>
								<th>&nbsp;</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
									<FormControl componentClass="select" placeholder="select" ref="flight" onChange={this.selectFlight.bind(this)}>
										{this.state.flights.map((flight) => (
											<option value={flight._id}>{flight.title}</option>
										))}
									</FormControl>
								</td>
								<td>
									SEMAINE : <FormControl type="text" ref="priceSemaine"/>
									LIBRE DATE : <FormControl type="text" ref="priceLibreDate"/>
									ENFANT : <FormControl type="text" ref="priceEnfant"/>
								</td>
								<td className="text-center"><Button bsStyle="success" onClick={this.onAdd.bind(this)}>+ AJOUTER</Button></td>
							</tr>
							{this.state.specialFlights.map((flight) => (
								<tr>
									<td>{flight.title}</td>
									<td>
										SEMAINE : {flight.priceSemaine}€<br/>
										LIBRE DATE : {flight.priceLibreDate}€<br/>
										ENFANT : {flight.priceEnfant}€
									</td>
									<td className="text-center"><Button bsStyle="danger" onClick={this.onDelete.bind(this, flight._id)}>Supprimer</Button></td>
								</tr>
							))}
						</tbody>
					</Table>
				</Col>
			</Col>
		);
	}

}



/** WEBPACK FOOTER **
 ** ./src/universal/components/partners/components/SpecialPrices.js
 **/